const lerp = (start: number, end: number, amt: number) => (1 - amt) * start + amt * end

export const animatedScrollTo = (target: number, duration: number, start = window.pageYOffset) => {
  // in case the browser doesn't support requestAnimationFrame (opera mini)
  let startTime: number | undefined = undefined

  if (!window.requestAnimationFrame) {
    return window.scroll(0, target)
  }

  function step(timestamp?: number) {
    if (startTime === undefined) {
      startTime = timestamp
    }

    const time = (Number(timestamp) - Number(startTime)) / duration

    if (time >= 1) {
      return window.scroll(0, target)
    }

    window.scroll(0, lerp(start, target, time))
    window.requestAnimationFrame((timestamp) => step(timestamp))
  }

  step(startTime)
}

export function scrollToHashWithOffset(hash: string, { duration = 200, offset = 0 } = {}): void {
  const element = document.querySelector<HTMLElement>(hash)
  if (element !== null) {
    animatedScrollTo(element.offsetTop - offset, duration)
  }
}
